export type PlanPeriod = "month" | "annual" | "once";

export type PlanApp = "patient" | "physician" | "institution";

export const PLAN_APP_LABEL: Record<PlanApp, string> = {
  patient: "Pacientes",
  physician: "Profesionales",
  institution: "Clínicas",
};

export const PLAN_PERIOD_LABEL: Record<PlanPeriod, string> = {
  month: "Mensual",
  annual: "Anual",
  once: "Pago único",
};

export const PLAN_APPS: PlanApp[] = ["patient", "physician", "institution"];

export const PLAN_PERIODS: PlanPeriod[] = ["month", "annual", "once"];

export interface Plan {
  docId: string;
  name: string;
  period: PlanPeriod;
  price: number;
  benefits: string[];
  /** App destino; undefined en planes legacy sin migrar. */
  app?: PlanApp;
  stripeId?: string;
  /** Price ID de Stripe (price_...). */
  stripePriceId?: string;
  /** ID del plan en Venflow. */
  venflowId?: string;
}

export interface CreatePlanInput {
  name: string;
  period: PlanPeriod;
  price: number;
  benefits: string[];
  app: PlanApp;
  stripeId?: string;
  stripePriceId?: string;
  venflowId?: string;
}

export type UpdatePlanInput = Partial<CreatePlanInput>;
